export default __webpack_public_path__ + "83123207b9146d4439d980ec03d42056.png";